import Button from '@rio-cloud/rio-uikit/Button';
import { gaPush } from '../../configuration/setup/googleAnalytics';
import { useDriverChatMessages } from './useDriverChatMessages';

type Props = {
    trackingCategory: string;
    block?: boolean;
    withArrow?: boolean;
};

export const DriverChatUpsellingButton = ({ trackingCategory, block = false, withArrow = false }: Props) => {
    const { message, linkLanguage } = useDriverChatMessages();

    return (
        <Button
            as='a'
            href={`https://rio.cloud/${linkLanguage}/marketplace/produkt/order-communication`}
            target='_blank'
            rel='noopener noreferrer'
            bsStyle='primary'
            bsSize='lg'
            block={block}
            className={block ? undefined : 'text-wrap-balance'}
            iconName={withArrow ? 'arrow-right' : undefined}
            iconRight={withArrow}
            multiline
            onClick={() => {
                gaPush({
                    category: trackingCategory,
                    action: 'Learn more',
                    label: 'Clicked learn more link in upselling advertisement',
                });
            }}
        >
            {message('cta')}
        </Button>
    );
};
